"use client";
import { ButtonComponent, ModalComponent } from "@/components";
import { useRouter } from "@/i18n/routing";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { Stack, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useEffect, useState } from "react";

const ErrorModal = ({ open, handleModal, data }) => {
  const t = useTranslations("ErrorModal");
  const router = useRouter();
  const [errorModalDetails, setErrorModalDetails] = useState({
    hideCloseBtn: false,
    hideCtaBtn: false,
    label: "Service Error",
    subLabel: "Something went wrong, Please Try Again Later",
    buttonLabel: "Retry",
  });

  useEffect(() => {
    const modalErrorType = data?.modalErrorType;
    if (modalErrorType) {
      const details = errorDetailsMap[modalErrorType] || errorModalDetails;
      setErrorModalDetails({
        error: data?.error,
        hideCloseBtn: Boolean(data?.hideCloseBtn || details?.hideCloseBtn),
        hideCtaBtn: Boolean(data?.hideCtaBtn || details?.hideCtaBtn),
        onBtnClick: data?.onBtnClick || details?.onBtnClick,
        label: details.label,
        subLabel: data?.subLabel || details.subLabel,
        buttonLabel: data?.buttonLabel || details.buttonLabel,
      });
    } else {
      if (!data?.label && !data?.subLabel) {
        return;
      }
      setErrorModalDetails({
        error: data?.error,
        hideCloseBtn: Boolean(data?.hideCloseBtn),
        label: data?.label,
        onBtnClick: data?.onBtnClick,
        subLabel: data?.subLabel,
        buttonLabel: data?.buttonLabel || "Retry",
      });
    }
  }, [data]);

  const errorDetailsMap = {
    bankDetailsErrorHeading: {
      label: t("bankDetailsErrorHeading.label"),
      subLabel: t("bankDetailsErrorHeading.subLabel"),
      buttonLabel: t("bankDetailsErrorHeading.button"),
    },
    nameMismatch: {
      label: t("nameMismatch.label"),
      subLabel: t("nameMismatch.subLabel"),
      buttonLabel: t("nameMismatch.button"),
    },
    creditQueue: {
      label: t("creditQueue.label"),
      subLabel:
        "Looks like, we would require to screen your application a little more. We will get back to you in next 24 hours",
      buttonLabel: t("creditQueue.button"),
    },
    creditQueueStage: {
      label: t("creditQueueStage.label"),
      subLabel: t("creditQueueStage.subLabel"),
      buttonLabel: t("creditQueueStage.button"),
    },
    creditQueueNameMismatch: {
      label: "Name Mismatch",
      subLabel:
        "Your name does not match as per bank details, your application has been sent for CREDIT review",
      buttonLabel: "Ok",
    },
    technicalIssue: {
      label: t("technicalIssue.label"),
      subLabel: t("technicalIssue.subLabel"),
      buttonLabel: t("technicalIssue.button"),
    },
    authError: {
      label: t("authError.label"),
      subLabel: t("authError.subLabel"),
      buttonLabel: t("authError.button"),
    },
    mandateFailed: {
      label: t("mandateFailed.label"),
      subLabel: t("mandateFailed.subLabel"),
      buttonLabel: t("mandateFailed.button"),
    },
    UPIMandateService: {
      label: t("UPIMandateService.label"),
      buttonLabel: t("UPIMandateService.button"),
    },
    serviceUnAvailable: {
      label: t("serviceUnAvailable.label"),
      buttonLabel: t("serviceUnAvailable.button"),
    },
    somethingWentRong: {
      label: t("somethingWentRong.label"),
      subLabel: t("somethingWentRong.subLabel"),
      buttonLabel: t("somethingWentRong.button"),
    },
    exhaustTryWithNewNumber: {
      label: t("exhaustTryWithNewNumber.label"),
      subLabel: t("exhaustTryWithNewNumber.subLabel"),
      buttonLabel: t("exhaustTryWithNewNumber.button"),
    },
    mandateFailedWithCreditQueue: {
      label: t("mandateFailedWithCreditQueue.label"),
      subLabel:
        "Looks like, we would require to screen your application a little more. We will get back to you in next 24 hours",
      buttonLabel: t("mandateFailedWithCreditQueue.button"),
    },
    upiMandateFailed: {
      label: t("upiMandateFailed.label"),
      subLabel: t("upiMandateFailed.subLabel"),
      buttonLabel: t("upiMandateFailed.button"),
    },
    emandateFailed: {
      label: "Mandate Failed",
      subLabel: "Your mandate has failed. Please try again.",
      buttonLabel: "Ok",
    },
  };

  return (
    <ModalComponent
      open={open}
      handleModal={handleModal}
      closeButtonRequired={!errorModalDetails.hideCloseBtn}
    >
      <Stack justifyContent="center" spacing={2} alignItems="center">
        <Stack justifyContent="center" alignItems="center">
          <Image
            src={
              data?.modalErrorType === "nameMismatch"
                ? IMAGES.nameMismatchError
                : data?.modalErrorType === "technicalIssue"
                  ? IMAGES.techinalIssues
                  : IMAGES.authenticationError
            }
            alt="repayment mode"
          />
        </Stack>
        <Typography align="center">{errorModalDetails.label}</Typography>
        <Typography align="center">{errorModalDetails.subLabel}</Typography>
        <Typography color={WEB_COLORS.errorColor} fontSize={12} align="center">
          {errorModalDetails.error}
        </Typography>

        {!errorModalDetails?.hideCtaBtn && (
          <ButtonComponent
            onClick={() => {
              if (typeof errorModalDetails?.onBtnClick === "function") {
                errorModalDetails?.onBtnClick();
              } else {
                handleModal(false);
                if (errorModalDetails.label === "Name Mismatch") {
                  router.replace("/");
                }
              }
            }}
            sx={{
              minWidth: "200px",
            }}
            buttonStyle={{
              fontSize: "clamp(0.75rem, 2vw, 1rem)",
              padding: "clamp(0.5rem, 1.5vw, 0.75rem) clamp(1rem, 3vw, 1.5rem)",
            }}
          >
            {errorModalDetails.buttonLabel}
          </ButtonComponent>
        )}
      </Stack>
    </ModalComponent>
  );
};

export default ErrorModal;
